export enum KassenSichVState {
  New,
  Created,
  Initialized,
  Disabled
}

export class KassenSichVStateHelper {
  public static toDisplayString(state: KassenSichVState): string {
    switch (state) {
      case KassenSichVState.New:
        return "Neu";
      case KassenSichVState.Created:
        return "Erstellt";
      case KassenSichVState.Initialized:
        return "Initialisiert";
      case KassenSichVState.Disabled:
        return "Deaktiviert";
      default:
        return "Unbekannt";
    }
  }

  public static getStates(): KassenSichVState[] {
    return [
      KassenSichVState.New,
      KassenSichVState.Created,
      KassenSichVState.Initialized,
      KassenSichVState.Disabled
    ];
  }

  /**
   * The one legal forward move from each state, plus the no-op of staying put (#613).
   *
   * Replaces the template's old `state - current.state < 0 || state - current.state > 1` arithmetic, which
   * happened to allow exactly "same state, or one step forward" but said nothing about *why* — and silently
   * broke the moment the enum stopped being contiguous (it still is, but nothing enforced that). An explicit
   * table says the rule once, by name, and cannot be defeated by reordering the enum.
   *
   * `Disabled` has no forward move at all: the old lifecycle's manual "Deaktiviert → Neu" jump is retired —
   * a disabled/defective/evicted/deleted TSE is recovered exclusively through "Neue TSE" (`ReInitialize`),
   * which mints a fresh id rather than reusing the dead one.
   */
  private static readonly FORWARD_TRANSITIONS: ReadonlyMap<KassenSichVState, KassenSichVState> = new Map([
    [KassenSichVState.New, KassenSichVState.Created],
    [KassenSichVState.Created, KassenSichVState.Initialized],
    [KassenSichVState.Initialized, KassenSichVState.Disabled]
  ]);

  /** Whether the "Status ändern" buttons may move FROM `current` TO `target` — same state, or the one forward move. */
  public static canTransitionTo(current: KassenSichVState, target: KassenSichVState): boolean {
    return target === current || KassenSichVStateHelper.FORWARD_TRANSITIONS.get(current) === target;
  }
}
